/* ============================================================
   カート追加トースト — Issue #70

   cart_type=page のとき、商品フォーム（.add-to-cart を持つ /cart/add フォーム）の
   submit を横取りして fetch で追加し、ページ遷移せずにトーストを出す。

   - theme.js は編集しない。成功時に theme.AjaxProduct と同名の
     `ajaxProduct:added` を bubbles:true で発火するので、HeaderCart → CartForm.buildCart()
     → updateCount() のバッジ更新は既存コードがそのまま動く。
   - theme.AjaxProduct を流用しないのは、fetch に catch が無くネットワークエラー時に
     ローディングが残るため（Issue #70 技術メモ）。
   - cart_type=dropdown では theme.js 側が AjaxProduct を適用するので何もしない。
   - カートページでは layout 側で読み込まない（AjaxProduct の location.reload() と干渉させない）。
   ============================================================ */
(function () {
  'use strict';

  var AUTO_DISMISS_MS = 5000;
  var OUT_MS = 160;
  var TOP_GAP = 12;
  var THUMB_WIDTH = 96; /* 表示 48×64px の 2 倍幅 (Retina)。高さは CSS の object-fit: cover で詰める */

  function init() {
    if (!window.theme || !theme.settings || theme.settings.cartType !== 'page') return;
    if (document.body.classList.contains('template-cart')) return;

    var toast = document.getElementById('CartToast');
    if (!toast) return;

    var els = {
      img: toast.querySelector('.cart-toast__img'),
      placeholder: toast.querySelector('.cart-toast__placeholder'),
      title: toast.querySelector('[data-toast-title]'),
      variant: toast.querySelector('[data-toast-variant]'),
      close: toast.querySelector('[data-toast-close]')
    };
    var genericError = toast.dataset.errorGeneric || '';
    var dismissTimer = null;
    var hideTimer = null;
    var loading = false;

    /* ---------- 商品フォームの submit を横取り（委譲。後から挿入されたフォームにも効く） ---------- */
    document.addEventListener('submit', function (evt) {
      var form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      var fallback = form.querySelector('.add-to-cart');
      if (!fallback) return;
      /* Appikon のプリオーダーボタンは元ボタンの class を複製してフォーム内に並ぶため、
         押されたボタン（submitter）を優先し、取れない環境では最初の .add-to-cart に倒す */
      var button = (evt.submitter && form.contains(evt.submitter)) ? evt.submitter : fallback;

      evt.preventDefault();
      if (loading) return;
      addToCart(form, button);
    }, true);

    function addToCart(form, button) {
      loading = true;
      button.classList.add('btn--loading');
      clearErrors(form);

      var formData = new FormData(form);
      var body = new URLSearchParams(formData);
      /* /cart/add.js のレスポンス quantity は同一バリエーションが既にあると累積値になり得るので、
         トーストの「× N」には送信した数量を使う */
      var requested = parseInt(formData.get('quantity'), 10);
      if (!(requested > 0)) requested = 1;
      var status = 0;

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          status = response.status;
          return response.json().catch(function () { return {}; });
        })
        .then(function (data) {
          if (status === 422) {
            onError(form, errorText(data) || genericError);
          } else if (status < 200 || status >= 300) {
            onError(form, genericError);
          } else {
            onSuccess(form, button, data, requested);
          }
        })
        .catch(function () {
          onError(form, genericError);
        })
        .then(function () {
          loading = false;
          button.classList.remove('btn--loading');
        });
    }

    function errorText(data) {
      if (!data) return '';
      if (typeof data.description === 'string') return data.description;
      if (typeof data.message === 'string') return data.message;
      return '';
    }

    function clearErrors(form) {
      var errors = form.querySelector('.errors');
      if (errors) errors.remove();
    }

    function onError(form, message) {
      /* 在庫不足の 422 でも Shopify は在庫分だけカートに入れたうえでエラーを返すことがある
         （例:「出品状況により、アイテム2点のみがカートに追加されました。」）。
         変更前はカートページに遷移して実状態が見えていたので、バッジだけは実状態に合わせる */
      refreshBadge();

      var errorDiv = document.createElement('div');
      errorDiv.classList.add('errors', 'text-center');
      errorDiv.textContent = message;
      form.append(errorDiv);

      form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: { errorMessage: message },
        bubbles: true
      }));
    }

    function refreshBadge() {
      fetch(theme.routes.cart, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
          if (count === null) return;
          document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) { el.innerText = count; });
          document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
            b.classList.toggle('cart-link__bubble--visible', count > 0);
          });
        })
        .catch(function () {});
    }

    function onSuccess(form, button, item, requested) {
      /* theme.js の HeaderCart がこれを受けてバッジと ドロワー内容を更新する */
      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: item, addToCartBtn: button },
        bubbles: true
      }));

      pulseBadgeOnUpdate();
      show(item, requested);
    }

    /* ---------- トースト表示 ---------- */
    function show(item, requested) {
      fill(item, requested);
      position();

      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      toast.hidden = false;
      /* display:none → 表示 の直後にクラスを付けると transition が効かないので 1 フレーム待つ */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          toast.classList.add('is-visible');
        });
      });

      restartDismiss();
      window.addEventListener('scroll', position, { passive: true });
      window.addEventListener('resize', position);
    }

    function hide() {
      stopDismiss();
      toast.classList.remove('is-visible');
      window.removeEventListener('scroll', position);
      window.removeEventListener('resize', position);
      hideTimer = setTimeout(function () {
        toast.hidden = true;
        hideTimer = null;
      }, OUT_MS);
    }

    function fill(item, requested) {
      els.title.textContent = item.product_title || '';

      var parts = [];
      if (item.variant_title && item.variant_title !== 'Default Title') {
        parts.push(item.variant_title);
      }
      if (requested > 1) {
        parts.push('× ' + requested);
      }
      if (parts.length) {
        els.variant.textContent = parts.join(' ');
        els.variant.hidden = false;
      } else {
        els.variant.textContent = '';
        els.variant.hidden = true;
      }

      var src = item.image || item.featured_image && item.featured_image.url;
      if (src) {
        els.img.src = thumbUrl(src);
        els.img.hidden = false;
        els.placeholder.hidden = true;
      } else {
        els.img.removeAttribute('src');
        els.img.hidden = true;
        els.placeholder.hidden = false;
      }
    }

    function thumbUrl(url) {
      if (!/cdn\.shopify\.com/.test(url)) return url;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + THUMB_WIDTH;
    }

    /* sticky ヘッダーの下端 + 12px。アナウンスバー込みでも実際の下端を取る */
    function position() {
      var header = document.querySelector('.site-header');
      var bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      toast.style.top = Math.round(bottom + TOP_GAP) + 'px';
    }

    /* ---------- 自動消去（ホバー / フォーカス中は停止、離れたら 5 秒を数え直す） ---------- */
    function restartDismiss() {
      stopDismiss();
      dismissTimer = setTimeout(hide, AUTO_DISMISS_MS);
    }

    function stopDismiss() {
      if (dismissTimer) { clearTimeout(dismissTimer); dismissTimer = null; }
    }

    function isVisible() {
      return !toast.hidden && toast.classList.contains('is-visible');
    }

    toast.addEventListener('mouseenter', stopDismiss);
    toast.addEventListener('mouseleave', function () {
      if (isVisible() && !toast.contains(document.activeElement)) restartDismiss();
    });
    toast.addEventListener('focusin', stopDismiss);
    toast.addEventListener('focusout', function (evt) {
      if (toast.contains(evt.relatedTarget)) return;
      if (isVisible() && !toast.matches(':hover')) restartDismiss();
    });

    els.close.addEventListener('click', hide);
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && isVisible()) hide();
    });

    /* ---------- バッジ脈動（HeaderCart の updateCount で数値が変わった瞬間に 1 回） ---------- */
    function pulseBadgeOnUpdate() {
      var num = document.querySelector('.cart-link__bubble-num');
      if (!num || typeof MutationObserver === 'undefined') return;
      var bubble = num.closest('.cart-link__bubble');
      if (!bubble) return;

      var observer = new MutationObserver(function () {
        observer.disconnect();
        clearTimeout(giveUp);
        pulse(bubble);
      });
      observer.observe(num, { childList: true, characterData: true, subtree: true });
      var giveUp = setTimeout(function () { observer.disconnect(); }, 3000);
    }

    function pulse(bubble) {
      bubble.classList.remove('cart-toast-pulse');
      /* 連続追加時も毎回アニメーションを再生させる */
      void bubble.offsetWidth;
      bubble.classList.add('cart-toast-pulse');
      bubble.addEventListener('animationend', function handler() {
        bubble.classList.remove('cart-toast-pulse');
        bubble.removeEventListener('animationend', handler);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
